export const deData = `
  <div class="paragraph">
    <div class="page-title">Häufig gestellte Fragen zum Trade-In-Programm (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Wer kann am Trade-In-Programm teilnehmen?</div>
    <div class="text-box">
      <div class="text">
        Der Trade-In-Service steht ausschließlich Personen ab 18 Jahren zur Verfügung, die ihren rechtmäßigen Wohnsitz in einem Mitgliedstaat der Europäischen Union haben, mit Ausnahme der Kanarischen Inseln, der Balearen, Ceuta und Melilla.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was sollte ich tun, bevor ich mein Altgerät einsende?</div>
    <div class="text-box">
      <div class="text">
        Bevor Sie Ihr Gerät einsenden:<br>
        • Löschen Sie alle persönlichen Daten und entfernen Sie alle PINs, Passwörter oder Displaysperren.<br>
        • Führen Sie einen vollständigen Werksreset durch.<br>
        • Bei iPhone: Trennen Sie Ihr iCloud-Konto, indem Sie "Mein iPhone suchen" deaktivieren.<br>
        • Bei Android: Entfernen Sie Ihr Google-Konto (Einstellungen > Konten > Google > Konto entfernen).<br>
        • Bei Action-Kameras: Entfernen Sie alle verknüpften Konten, löschen Sie sämtliche Mediendateien, formatieren Sie die Speicherkarte (sofern zutreffend) und führen Sie einen vollständigen Werksreset durch.<br>
        So stellen Sie sicher, dass Ihr Gerät nicht mehr mit Ihrem Konto verknüpft ist und Ihre persönlichen Daten geschützt bleiben.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wie kann ich mein Altgerät versenden?</div>
    <div class="text-box">
      <div class="text">
        <strong>Verpackung:</strong> Verwenden Sie eine stabile, undurchsichtige Schachtel (nicht transparent) und fügen Sie einen inneren Schutz (z. B. Luftpolsterfolie) hinzu, um Transportschäden zu vermeiden.<br>
        <strong>Verpackungsmaterialien:</strong> Wenn Sie keine geeigneten Verpackungsmaterialien haben, können Sie diese am Abgabepunkt anfordern, wenn Sie Ihr Paket abgeben.<br>
        <strong>Dokumentation:</strong> Drucken Sie die Ehrlichkeitserklärung aus, füllen Sie sie aus, unterschreiben Sie sie und legen Sie sie vor dem Verschließen in das Paket.<br>
        <strong>Sicheres Verschließen:</strong> Stellen Sie sicher, dass das Paket gut verschlossen ist, und befestigen Sie das kostenlose Versandetikett gut sichtbar außen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Welche Arten von Geräten werden nicht akzeptiert?</div>
    <div class="text-box">
      <div class="text">
        Wir akzeptieren keine Geräte, die:<br>
        •	mit einem SIM-Lock versehen sind;<br>
        •	sich nicht einschalten oder laden lassen;<br>
        •	keine Verbindung über Bluetooth oder WLAN herstellen können;<br>
        •	einen Defekt interner Komponenten oder des Mainboards aufweisen;<br>
        •	keine Fotos aufnehmen oder Videos ordnungsgemäß aufzeichnen können;<br>
        •	über gesprungene Linsen oder schwere strukturelle Schäden verfügen;<br>
        •	defekte Tasten oder Stabilisierungsprobleme aufweisen;<br>
        •	Flüssigkeitsschäden erlitten haben oder repariert/demontiert wurden;<br>
        •	noch mit iCloud, Google oder einem Benutzerkonto verknüpft sind;<br>
        •	Fälschungen oder Replikate sind;<br>
        •	stark beschädigt sind.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Muss ich Zubehör (Ladegerät, Kabel usw.) mitsenden?</div>
    <div class="text-box">
      <div class="text">
        Das ist nicht verpflichtend, wird jedoch empfohlen. Das Beilegen von Zubehör unterstützt Nachhaltigkeit und die Wiederverwendung der Geräte.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Muss ich Kopfhörer mitsenden?</div>
    <div class="text-box">
      <div class="text">
        Nein. Aus hygienischen Gründen werden Kopfhörer entsorgt und nicht in die Bewertung einbezogen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Muss ich die Kaufrechnung mitsenden?</div>
    <div class="text-box">
      <div class="text">
        Nein, die Rechnung wird weder für die Bewertung noch für die Auszahlung benötigt. Sie können sie für Ihre eigenen Unterlagen aufbewahren.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wie wird mein Altgerät bewertet?</div>
    <div class="text-box">
      <div class="text">
        Wir verwenden zertifizierte Diagnosesoftware und führen eine manuelle Prüfung in unserem Bewertungszentrum durch, um den Zustand Ihres Geräts zu bestimmen. Alle Bewertungs- und Datenverarbeitungsverfahren erfolgen in Übereinstimmung mit der Datenschutz-Grundverordnung (DSGVO – EU 2016/679) und gewährleisten die Sicherheit und Vertraulichkeit Ihrer Daten.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was passiert, wenn der von mir angegebene Zustand nicht mit eurer Bewertung übereinstimmt?</div>
    <div class="text-box">
      <div class="text">
        Wenn Abweichungen zwischen dem angegebenen und dem tatsächlichen Zustand festgestellt werden, senden wir Ihnen eine E-Mail mit:<br>
        •	<strong>einem aktualisierten Angebot</strong> basierend auf der tatsächlichen Inspektion;<br>
        •	<strong>dem Diagnosebericht</strong> und den Gründen für die Abweichung.<br><br>
        Sie können das Angebot annehmen oder ablehnen:<br>
        •	Wenn Sie annehmen, wird der Trade-In-Vorgang abgeschlossen, und Sie erhalten die Zahlung innerhalb von 3 Werktagen auf Ihr Bankkonto.<br>
        •	Wenn Sie ablehnen, hängt der Rücksendeprozess von Ihrem Standort ab:<br>
        &nbsp;&nbsp;•	Für alle Kunden fällt eine Rücksendegebühr von bis zu maximal 22 € (inkl. MwSt.) an.<br>
        &nbsp;&nbsp;•	Die Gebühr ist innerhalb von fünf (5) Kalendertagen nach Erhalt der Zahlungsaufforderung unter Verwendung des von Danghuan bereitgestellten offiziellen vorausbezahlten Rücksendeetiketts zu entrichten.<br>
        &nbsp;&nbsp;•	Die Zahlungsinformationen werden auf Anfrage bereitgestellt oder sind in der Zahlungslink-E-Mail enthalten.<br>
        &nbsp;&nbsp;•	Nach Bestätigung des Zahlungseingangs überprüft Danghuan die Transaktion innerhalb von fünf (5) Werktagen und organisiert die Rücksendung an die ursprüngliche Versandadresse. Der Kunde wird per E-Mail benachrichtigt, sobald die Sendung versandt wurde, einschließlich der entsprechenden Sendungsverfolgungsnummer.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was passiert, wenn ich nicht auf das aktualisierte Angebot reagiere?</div>
    <div class="text-box">
      <div class="text">
        Erfolgt innerhalb von fünf (5) Kalendertagen ab dem Benachrichtigungsdatum keine Rückmeldung, gilt das überarbeitete Angebot automatisch als angenommen, ohne weitere Mitteilung, Erinnerung oder zusätzliche Kommunikation durch Danghuan.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was geschieht mit meinen personenbezogenen Daten?</div>
    <div class="text-box">
      <div class="text">
        Sie müssen alle Daten löschen, bevor Sie Ihr Altgerät einsenden. Wenn wir verbleibende Daten feststellen, pausieren wir den Prozess und kontaktieren Sie, um diese zu entfernen. Wir erfüllen vollständig die Anforderungen der DSGVO (Verordnung EU 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wer trägt die Versandkosten?</div>
    <div class="text-box">
      <div class="text">
        Der Erstversand ist immer kostenlos.<br><br>
        Wenn Sie das aktualisierte Angebot ablehnen:<br>
        •	Für alle Kunden fällt eine Rücksendegebühr von bis zu maximal 22 € (inkl. MwSt.) an.<br>
        •	Die Gebühr ist innerhalb von fünf (5) Kalendertagen nach Erhalt der Zahlungsaufforderung unter Verwendung des von Danghuan bereitgestellten offiziellen vorausbezahlten Rücksendeetiketts zu entrichten.<br>
        •	Die Zahlungsinformationen werden auf Anfrage bereitgestellt oder sind in der Zahlungslink-E-Mail enthalten.<br>
        •	Sobald die Zahlung (falls zutreffend) bestätigt wurde, überprüft Danghuan die Transaktion innerhalb von 5 Werktagen und organisiert den Rückversand an Ihre ursprüngliche Adresse. Sie werden per E-Mail informiert, sobald das Paket versandt wurde, einschließlich der entsprechenden Sendungsverfolgungsinformationen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was passiert, wenn mein Paket während des Versands verloren geht?</div>
    <div class="text-box">
      <div class="text">
        Wenn Ihr Gerät während des Transports verloren geht, unterstützt Danghuan Europe S.L. Sie beim offiziellen Reklamationsprozess des Kurierdienstes.<br><br>
        Eine Sendung gilt als verloren, wenn sie innerhalb von 15 Kalendertagen nach Übergabe an den Kurier nicht nachverfolgt, bestätigt oder von Danghuan erhalten wurde.<br><br>
        •	Sie müssen das autorisierte, vorfrankierte Versandetikett von Danghuan verwenden; jede andere Versandmethode schließt den Verlustschutz aus.<br>
        •	Reklamationen bei UPS müssen innerhalb von 60 Tagen nach Erstellung des Etiketts eingereicht werden.<br>
        •	Bei CORREOS (Spanien)-Sendungen sollten Reklamationen so früh wie möglich, idealerweise innerhalb von 15 Tagen und spätestens innerhalb eines Jahres nach Versanddatum eingereicht werden.<br>
        •	Danghuan unterstützt bei der Untersuchung des Kurierdienstes, die in der Regel 30–60 Tage dauert.<br><br>
        Wenn der Verlust im Danghuan-Logistiksystem bestätigt wird und das autorisierte Etikett verwendet wurde, übersteigt die Entschädigung nicht den endgültig bewerteten Trade-In-Wert des Geräts.<br><br>
        Genehmigte Zahlungen werden direkt auf das bei der Registrierung angegebene IBAN überwiesen.<br><br>
        <em>Hinweis: Jede Entschädigung hängt von der Richtlinie des jeweiligen Kurierdienstes ab.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wann erhalte ich die Zahlung?</div>
    <div class="text-box">
      <div class="text">
        Nach Annahme des endgültigen Angebots erfolgt die Auszahlung per Banküberweisung innerhalb von 3 Werktagen. Bitte stellen Sie sicher, dass Ihre IBAN und Ihre Personalausweisnummer korrekt sind und mit dem Kontoinhaber übereinstimmen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Ist die Angabe meiner Personalausweisnummer verpflichtend?</div>
    <div class="text-box">
      <div class="text">
        Ja. Um die Zahlung zu verarbeiten, müssen Sie eine gültige Personalausweisnummer angeben, ohne Leerzeichen oder Sonderzeichen, die mit dem Inhaber des IBAN-Kontos übereinstimmt.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kann ich meine Trade-In-Transaktion stornieren?</div>
    <div class="text-box">
      <div class="text">
        Ja, sofern Ihr Altgerät noch nicht bezahlt wurde. Bitte kontaktieren Sie uns so schnell wie möglich unter insta360@danghuan.eu. Wenn Sie Ihr Gerät bereits versendet haben, kontaktieren Sie uns bitte innerhalb von 48 Stunden; andernfalls wird der Recyclingprozess wie vorgesehen fortgesetzt.
      </div>
    </div>
  </div>
`;